import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-center gap-1.5" }

import { computed } from 'vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'StatusIndicator',
  props: {
    active: { type: [Boolean, Number, null] },
    status: {},
    type: { default: 'activeInactive' }
  },
  setup(__props: any) {

    const props = __props;

    const statusText = computed(() => {
        if (props.type === 'companyStatus' && props.status) {
            switch (props.status) {
                case 'active':
                    return 'translations.status.active';
                case 'inactive':
                    return 'translations.status.inactive';
                case 'deleted':
                    return 'translations.deleted';
                default:
                    return 'translations.status.inactive';
            }
        }

        if (props.type === 'yesNo') {
            return props.active ? 'forms.yes' : 'forms.no';
        }

        if (props.type === 'invoiceStatus') {
            return props.active ? 'translations.status.paid' : 'translations.status.unpaid';
        }

        return props.active ? 'translations.status.active' : 'translations.status.inactive';
    });

    const statusColor = computed(() => {
        if (props.type === 'companyStatus' && props.status) {
            switch (props.status) {
                case 'active':
                    return 'bg-accent';
                case 'inactive':
                case 'deleted':
                    return 'bg-destructive';
                default:
                    return 'bg-destructive';
            }
        }

        return props.active ? 'bg-accent' : 'bg-destructive';
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", {
      class: _normalizeClass(["size-3 rounded-full", statusColor.value])
    }, null, 2),
    _createElementVNode("span", null, _toDisplayString(_ctx.$t(statusText.value)), 1)
  ]))
}
}

})